import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { connect } from 'react-redux';
import { login } from '../../../store/actions/driver/Driver';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: '20px'
  },
  paper: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  alert: {
    textAlign: 'center',
    color: 'red'
  }
}));

const Login = (props) => {
  const { auth } = props;

  const handleChange = (e) => {
    setemail(e.target.value);
  };

  const handleChange1 = (e) => {
    setpassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.login({ emailId, authPassword });
    if (props.auth) {
      props.history.push('/driver');
    }
  };
  const classes = useStyles();
  const [emailId, setemail] = useState('');
  const [authPassword, setpassword] = useState('');
  return (
    <div className={classes.content}>
      {auth ? (window.location.href = '/driver') : ''}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Driver Login
          </Typography>
          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="emailId"
              label="Email Address"
              name="emailId"
              autoComplete="email"
              autoFocus
              onChange={handleChange}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="authPassword"
              label="Password"
              type="password"
              id="authPassword"
              autoComplete="current-password"
              onChange={handleChange1}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Login
            </Button>
            {/* {authError ? <p className={classes.alert}>{authError}</p> : null} */}
          </form>
        </div>
        <Box mt={8}></Box>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    driver: state.driver.driver,
    auth: state.driver.auth
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (creds) => dispatch(login(creds))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
